/**
 * @Description 客群画像第三页
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import PPTPieChart from '../PieChart';
// import cs from 'classnames';
import PPTBarChart from '../BarChart';

const PassengerFlowPortraitThree:FC<any> = ({
  rangeName,
  normalInfoVO
}) => {
  // const pieData = [{ value: 58, name: '高' },
  //   { value: 11, name: '次高' },
  //   { value: 13, name: '中' },
  //   { value: 5, name: '次低' },
  //   { value: 66, name: '低' }];

  const consumptionText = useMemo(() => {
    const housePrice = normalInfoVO?.complex?.housePrice;
    if (!housePrice) return '';
    if (housePrice.includes('-')) {
      const priceArr = housePrice.split('-');
      const min = +priceArr[0];
      const max = +priceArr[1];
      if (min >= 20000) {
        return '本区域消费水平较高';
      } else if (min >= 8000 && max < 20000) {
        return '本区域消费水平居中';
      } else if (max < 8000) {
        return '本区域消费水平较低';
      }
    } else if (housePrice.includes('以上')) {
      return '本区域消费水平较高';
    }
    return '';
  }, [normalInfoVO]);

  return (
    <div className={styles['page']}>
      <Header title={`客流消费水平 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['side']}>
          <div className={styles['side-description']}>
            {`${consumptionText ? consumptionText + ',' : ''}房价${normalInfoVO?.complex.housePrice || ''}的占比最高为${normalInfoVO?.complex.housePriceRatio || ''}。`}
          </div>
          {/* <div className={cs(styles['side-card'], styles['pie'])}>
            <PPTPieChart
              title='消费水平'
              type='circle'
              height={252}
              seriesData={[{
                data: normalInfoVO?.consumption || [],
              }]}
              config={{
                legend: {
                  height: '100%',
                  itemGap: 20,
                  left: '300px'
                },
              }}/>
          </div> */}

          <div className={styles['side-content']}>
            <div className={styles['side-card']}>
              <PPTPieChart
                title='居住社区房价等级'
                type='circle'
                height={324}
                seriesData={[{
                  data: normalInfoVO?.housePrice || [],
                  center: [162, '50%'],
                  radius: [101, 126]
                }]}
                config={{
                  legend: {
                    height: '100%',
                    itemGap: 5,
                    left: '324px'
                  },
                  title: {
                    left: 60,
                    textStyle: {
                      color: '#222222',
                      fontWeight: 500,
                      fontFamily: 'PingFangSC, PingFang SC',
                      fontSize: 24,
                      lineHeight: 33,
                      width: 200,
                      align: 'center'
                    }
                  },
                  grid: {
                    left: 24,
                    top: 32
                  }
                }}/>
            </div>
          </div>
        </div>

        <div className={styles['side']}>
          <div className={styles['side-description']}>
            {`本区域日均客流${normalInfoVO?.complex.visiting || ''}类占比最高。`}
          </div>
          <div className={styles['side-content']}>
            <div className={styles['side-card']}>
              <PPTBarChart
                width={663}
                height={327}
                title='客流到访偏好'
                xAxisData={normalInfoVO?.visiting?.slice(0, 6)?.map((item) => item.name) || []}
                direction='horizontal'
                percent
                seriesData={[{
                  data: normalInfoVO?.visiting?.slice(0, 6)?.map((item) => item.value) || [],
                  itemStyle: {
                    color: '#8B3DFF',
                    borderRadius: [0, 100, 100, 0]
                  },
                  barWidth: 20,
                }]}
                config={{
                  yAxis: {
                    show: false
                  },
                  xAxis: {
                    axisLabel: {
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400,
                      width: 74,
                      align: 'right',
                      overflow: 'truncate',
                    },
                  },
                  title: {
                    top: 24,
                    left: 24,
                    textStyle: {
                      color: '#222222',
                      fontWeight: 500,
                      fontSize: 24,
                      lineHeight: 33,
                    },
                  },
                  grid: {
                    top: 75,
                    left: 104,
                    bottom: 37,
                    right: 80
                  },
                  legend: {
                    show: false
                  }
                }}
              />
            </div>
          </div>

          {/* <div className={styles['side-card']}>
            <PPTBarChart
              width={663}
              height={327}
              title='客流APP偏好'
              xAxisData={normalInfoVO?.app?.slice(0, 6)?.map((item) => item.name) || []}
              direction='horizontal'
              percent
              seriesData={[{
                data: normalInfoVO?.app?.slice(0, 6)?.map((item) => item.value) || [],
                itemStyle: {
                  color: '#8B3DFF',
                  borderRadius: [0, 100, 100, 0]
                },
                barWidth: 20,
              }]}
              config={{
                yAxis: {
                  show: false
                },
                xAxis: {
                  axisLabel: {
                    color: '#999999',
                    lineHeight: 22,
                    fontSize: 16,
                    fontWeight: 400,
                    width: 74,
                    align: 'right',
                    overflow: 'truncate',
                  },
                },
                title: {
                  top: 24,
                  left: 24,
                  textStyle: {
                    color: '#222222',
                    fontWeight: 500,
                    fontSize: 24,
                    lineHeight: 33,
                  },
                },
                grid: {
                  top: 75,
                  left: 104,
                  bottom: 37,
                  right: 80
                },
                legend: {
                  show: false
                }
              }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PassengerFlowPortraitThree;
